//React
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

//External Packages
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGripLinesVertical,
  faRotateRight,
} from "@fortawesome/free-solid-svg-icons";

//Internal Components
import {
  ValuesIcon,
  VisionIcon,
  IkigaiIcon,
  QuoteIconV2,
  HideOverlayIcon,
  OneIconMob,
  TwoIconMob,
  ThreeIconMob,
  FourIconMob,
  FiveIconMob,
  SixIconMob,
  SevenIconMob,
  EightIconMob,
  NineIconMob,
  TenIconMob,
  VitIcon,
  SaveIcon,
} from "../../../components/ui/Icons/Icon";
import { labelMaker } from "../../../utils/UtilityFunctions";

//Styling
import "./dock.css";

export function FullDockMobileOne({
  meyear,
  handleMouseState,
  yearList,
  handleNav,
  yearid,
}) {
  const navigate = useNavigate();

  let leng = yearList && yearList.years && yearList.years.length - 1;

  return (
    <div
      className={"mobiledock--container center"}
      style={{ justifyContent: "space-evenly" }}
    >
      <div
        className={`mobiledock node`}
        onClick={() => {
          handleMouseState("me");
        }}
      >
        {meyear && meyear && meyear.name && meyear.birthday ? (
          <VitIcon />
        ) : (
          <a
            href={
              yearList && yearList.years && yearList.years.length > 0
                ? `/year/${yearList.years[leng]._id}`
                : "/year/create"
            }
          >
            <VitIcon opacity="0.5" />
          </a>
        )}
      </div>

      <div
        className={`mobiledock node`}
        onClick={() => {
          handleMouseState("values");
        }}
      >
        {meyear && meyear && meyear.values ? (
          <ValuesIcon />
        ) : (
          <a
            href={
              yearList && yearList.years && yearList.years.length > 0
                ? `/year/${yearList.years[leng]._id}`
                : "/year/create"
            }
          >
            <ValuesIcon opacity="0.5" />
          </a>
        )}
      </div>

      <div className="mobileDockNodeWrapper">
        <div
          className={`mobiledockwide node`}
          onClick={() => {
            handleMouseState("vision");
          }}
        >
          {meyear && meyear && meyear.vision ? (
            <VisionIcon />
          ) : (
            <a
              href={
                yearList && yearList.years && yearList.years.length > 0
                  ? `/year/${yearList.years[leng]._id}`
                  : "/year/create"
              }
            >
              <VisionIcon opacity="0.5" />
            </a>
          )}
        </div>
      </div>

      <div
        className={`mobiledock node`}
        onClick={() => {
          handleMouseState("ikigai");
        }}
      >
        {meyear && meyear && meyear.ikigai ? (
          <IkigaiIcon />
        ) : (
          <a
            href={
              yearList && yearList.years && yearList.years.length > 0
                ? `/year/${yearList.years[leng]._id}`
                : "/year/create"
            }
          >
            <IkigaiIcon opacity="0.5" />
          </a>
        )}
      </div>
      <div
        className={`mobiledock node`}
        data-tooltip="My Quote"
        onClick={() => {
          handleMouseState("quote");
        }}
      >
        {meyear && meyear && meyear.quote ? (
          <QuoteIconV2 />
        ) : (
          <a
            href={
              yearList && yearList.years && yearList.years.length > 0
                ? `/year/${yearList.years[leng]._id}`
                : "/year/create"
            }
          >
            <QuoteIconV2 opacity="0.5" />
          </a>
        )}
      </div>
    </div>
  );
}

export function FullDockMobileTwo({
  handleColumnChange,
  objectives,
  variant,
  load,
  handleSubmit,
  handleRefresh,
}) {
  const [valuesShowState, setValuesShowState] = useState("mini node inactive");
  const [visionShowState, setVisionShowState] = useState("mini node inactive");
  const [currentWindow, setCurrentWindow] = useState(window.location.href);

  const [saveTooltip, setSaveTooltip] = useState("");

  const handleTooltipChange = () => {
    setSaveTooltip("Saving...");
    setTimeout(() => {
      setSaveTooltip("Saved");
    }, 1200);
  };

  let numIconObj = {
    "obj-one": OneIconMob,
    "obj-two": TwoIconMob,
    "obj-three": ThreeIconMob,
    "obj-four": FourIconMob,
    "obj-five": FiveIconMob,
    "obj-six": SixIconMob,
    "obj-seven": SevenIconMob,
    "obj-eight": EightIconMob,
    "obj-nine": NineIconMob,
    "obj-ten": TenIconMob,
  };

  const filteredArray = Object.entries(objectives)
    .filter(([key, obj]) => obj.title.trim() !== "")
    .map(([key, obj]) => ({ key, icon: numIconObj[key], ...obj }));

  return (
    <div
      className={
        variant === "week"
          ? "mobiledock--container-week"
          : "mobiledock--container"
      }
    >
      {filteredArray.map((objective, index) => {
        const IconComponent = objective.icon;

        return (
          <div
            key={index}
            className={
              variant === "week" ? `mobiledockweek node` : `mobiledock node`
            }
            data-tooltip={
              objectives[objective.key]?.title
                ? objectives[objective.key].title.slice(0, 20).length >= 20
                  ? objectives[objective.key].title.slice(0, 20) + "..."
                  : objectives[objective.key].title
                : "Add an objective into your week planner to access it here."
            }
            data-name={objective.key}
            onClick={(e) => handleColumnChange(e)}
          >
            {objectives && IconComponent && (
              <IconComponent
                opacity={objectives[objective.key]?.score}
                text={
                  objectives[objective.key]?.title &&
                  labelMaker(objectives[objective.key].title)
                }
              />
            )}
          </div>
        );
      })}
    </div>

    // <div
    //   className={
    //     variant === "week"
    //       ? "mobiledock--container-week"
    //       : "mobiledock--container"
    //   }
    // >
    //   <div
    //     className={
    //       variant === "week" ? `mobiledockweek node` : `mobiledock node`
    //     }
    //     data-tooltip={
    //       objectives["obj-one"]?.title
    //         ? objectives["obj-one"].title.slice(0, 20) + "..."
    //         : "Add an objective into your week planner to access it here."
    //     }
    //     data-name="obj-one"
    //     onClick={(e) => {
    //       handleColumnChange(e);
    //     }}
    //   >
    //     {objectives["obj-one"]?.title ? (
    //       <OneIconMob
    //         opacity={objectives["obj-one"]?.score}
    //         text={labelMaker(
    //           objectives["obj-one"]?.title && objectives["obj-one"].title
    //         )}
    //       />
    //     ) : (
    //       <OneIconMob opacity={objectives["obj-one"]?.score} op="0.5" />
    //     )}
    //   </div>
    //   <div
    //     className={`mobiledock node`}
    //     data-tooltip={
    //       objectives["obj-two"]?.title
    //         ? objectives["obj-two"].title.slice(0, 20) + "..."
    //         : "Add an objective into your week planner to access it here."
    //     }
    //     data-name="obj-two"
    //     onClick={(e) => handleColumnChange(e)}
    //   >
    //     {objectives["obj-two"]?.title ? (
    //       <TwoIconMob
    //         opacity={objectives["obj-two"]?.score}
    //         text={labelMaker(
    //           objectives["obj-two"]?.title && objectives["obj-two"].title
    //         )}
    //       />
    //     ) : (
    //       <TwoIconMob opacity={objectives["obj-two"]?.score} op="0.5" />
    //     )}
    //   </div>
    //   <div
    //     className={`mobiledock node`}
    //     data-tooltip={
    //       objectives["obj-three"]?.title
    //         ? objectives["obj-three"].title.slice(0, 20) + "..."
    //         : "Add an objective into your week planner to access it here."
    //     }
    //     data-name="obj-three"
    //     onClick={(e) => {
    //       handleColumnChange(e);
    //     }}
    //   >
    //     {objectives["obj-three"]?.title ? (
    //       <ThreeIconMob
    //         opacity={objectives["obj-three"]?.score}
    //         text={labelMaker(
    //           objectives["obj-three"]?.title && objectives["obj-three"].title
    //         )}
    //       />
    //     ) : (
    //       <ThreeIconMob opacity={objectives["obj-three"]?.score} op="0.5" />
    //     )}
    //   </div>
    //   <div
    //     className={`mobiledock node`}
    //     data-tooltip={
    //       objectives["obj-four"]?.title
    //         ? objectives["obj-four"].title.slice(0, 20) + "..."
    //         : "Add an objective into your week planner to access it here."
    //     }
    //     data-name="obj-four"
    //     onClick={(e) => {
    //       handleColumnChange(e);
    //     }}
    //   >
    //     {objectives["obj-four"]?.title ? (
    //       <FourIconMob
    //         opacity={objectives["obj-four"]?.score}
    //         text={labelMaker(
    //           objectives["obj-four"]?.title && objectives["obj-four"].title
    //         )}
    //       />
    //     ) : (
    //       <FourIconMob opacity={objectives["obj-four"]?.score} op="0.5" />
    //     )}
    //   </div>
    //   <div
    //     className={`mobiledock node`}
    //     data-tooltip={
    //       objectives["obj-five"]?.title
    //         ? objectives["obj-five"].title.slice(0, 20) + "..."
    //         : "Add an objective into your week planner to access it here."
    //     }
    //     data-name="obj-five"
    //     onClick={(e) => {
    //       handleColumnChange(e);
    //     }}
    //   >
    //     {objectives["obj-five"]?.title ? (
    //       <FiveIconMob
    //         opacity={objectives["obj-five"]?.score}
    //         text={labelMaker(
    //           objectives["obj-five"]?.title && objectives["obj-five"].title
    //         )}
    //       />
    //     ) : (
    //       <FiveIconMob opacity={objectives["obj-five"]?.score} op="0.5" />
    //     )}
    //   </div>
    //   <div
    //     className={`mobiledock node`}
    //     data-tooltip={
    //       objectives["obj-six"]?.title
    //         ? objectives["obj-six"].title.slice(0, 20) + "..."
    //         : "Add an objective into your week planner to access it here."
    //     }
    //     data-name="obj-six"
    //     onClick={(e) => {
    //       handleColumnChange(e);
    //     }}
    //   >
    //     {objectives["obj-six"]?.title ? (
    //       <SixIconMob
    //         opacity={objectives["obj-six"]?.score}
    //         text={labelMaker(
    //           objectives["obj-six"]?.title && objectives["obj-six"].title
    //         )}
    //       />
    //     ) : (
    //       <SixIconMob opacity={objectives["obj-six"]?.score} op="0.5" />
    //     )}
    //   </div>
    //   <div
    //     className={`mobiledock node`}
    //     data-tooltip={
    //       objectives["obj-seven"]?.title
    //         ? objectives["obj-seven"].title.slice(0, 20) + "..."
    //         : "Add an objective into your week planner to access it here."
    //     }
    //     data-name="obj-seven"
    //     onClick={(e) => {
    //       handleColumnChange(e);
    //     }}
    //   >
    //     {objectives["obj-seven"]?.title ? (
    //       <SevenIconMob
    //         opacity={objectives["obj-seven"]?.score}
    //         text={labelMaker(
    //           objectives["obj-seven"]?.title && objectives["obj-seven"].title
    //         )}
    //       />
    //     ) : (
    //       <SevenIconMob opacity={objectives["obj-seven"]?.score} op="0.5" />
    //     )}
    //   </div>
    //   <div
    //     className={`mobiledock node`}
    //     data-tooltip={
    //       objectives["obj-eight"]?.title
    //         ? objectives["obj-eight"].title.slice(0, 20) + "..."
    //         : "Add an objective into your week planner to access it here."
    //     }
    //     data-name="obj-eight"
    //     onClick={(e) => {
    //       handleColumnChange(e);
    //     }}
    //   >
    //     {objectives["obj-eight"]?.title ? (
    //       <EightIconMob
    //         opacity={objectives["obj-eight"]?.score}
    //         text={labelMaker(
    //           objectives["obj-eight"]?.title && objectives["obj-eight"].title
    //         )}
    //       />
    //     ) : (
    //       <EightIconMob opacity={objectives["obj-eight"]?.score} op="0.5" />
    //     )}
    //   </div>
    //   <div
    //     className={`mobiledock node`}
    //     data-tooltip={
    //       objectives["obj-nine"]?.title
    //         ? objectives["obj-nine"].title.slice(0, 20) + "..."
    //         : "Add an objective into your week planner to access it here."
    //     }
    //     data-name="obj-nine"
    //     onClick={(e) => {
    //       handleColumnChange(e);
    //     }}
    //   >
    //     {objectives["obj-nine"]?.title ? (
    //       <NineIconMob
    //         opacity={objectives["obj-nine"]?.score}
    //         text={labelMaker(
    //           objectives["obj-nine"]?.title && objectives["obj-nine"].title
    //         )}
    //       />
    //     ) : (
    //       <NineIconMob opacity={objectives["obj-nine"]?.score} op="0.5" />
    //     )}
    //   </div>
    //   <div
    //     id="finalnode"
    //     className={`mobiledock node`}
    //     data-tooltip={
    //       objectives["obj-ten"]?.title
    //         ? objectives["obj-ten"].title.slice(0, 20) + "..."
    //         : "Add an objective into your week planner to access it here."
    //     }
    //     data-name="obj-ten"
    //     onClick={(e) => {
    //       handleColumnChange(e);
    //     }}
    //   >
    //     {objectives["obj-ten"]?.title ? (
    //       <TenIconMob
    //         opacity={objectives["obj-ten"]?.score}
    //         text={labelMaker(
    //           objectives["obj-ten"]?.title && objectives["obj-ten"].title
    //         )}
    //       />
    //     ) : (
    //       <TenIconMob opacity={objectives["obj-ten"]?.score} op="0.5" />
    //     )}
    //   </div>

    //   {variant === "week" && (
    //     <>
    //       <div
    //         id="refresh"
    //         className={`mobiledock node ${load}`}
    //         data-tooltip={load === "success" ? saveTooltip : "Refresh"}
    //         onClick={() => {
    //           handleRefresh();
    //         }}
    //       >
    //         <FontAwesomeIcon
    //           icon={faRotateRight}
    //           size="2x"
    //           style={{ color: "#004a22", opacity: "0.8" }}
    //         />
    //       </div>
    //       <div
    //         className={`mobiledock node ${load}`}
    //         data-tooltip={load === "success" ? saveTooltip : "Click to Save"}
    //         onClick={(e) => {
    //           handleSubmit(e);
    //           handleTooltipChange();
    //         }}
    //       >
    //         <SaveIcon load={load} />
    //       </div>
    //     </>
    //   )}
    // </div>
  );
}
